var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14ZM7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13ZM6 6H5C5 4.71336 5.72254 4 7 4C8.27746 4 9 4.71336 9 6C9 6.81152 8.48651 7.53418 7.72018 7.80117L7.3355 7.93519C7.13461 8.00519 7 8.19463 7 8.40736V9H6V8.40736C6 7.76916 6.40382 7.20084 7.00649 6.99087L7.39117 6.85684C7.75573 6.72983 8 6.38605 8 6C8 5.26304 7.72254 5 7 5C6.27746 5 6 5.26304 6 6ZM6 10H7V11H6V10Z",
    fill: "#000624",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.0751fc90a6f824d5e2d47a048615255a.svg";
export { ForwardRef as ReactComponent };